module.exports = __webpack_public_path__ + "img/avatar-icon-circle.90a63d7c.svg";